import { i18nFor } from "./index";
import { parsePath } from "./locales";
import source from "./ui/en.json";

const keys = new Map(Object.entries(source).map(([key, value]) => [value, key]));

/** Fixed-language lookup shared by SSR metadata and visible UI. Never changes data IDs. */
export function currentUiLocale(): string {
  if (typeof window !== "undefined") return parsePath(window.location.pathname).locale;
  const store = (globalThis as { __statlignRequestPathname?: { getStore: () => string | undefined } })
    .__statlignRequestPathname;
  return parsePath(store?.getStore() || "/").locale;
}

export function uiText(text: string | null | undefined, values?: Record<string, unknown>): string {
  if (text == null) return "";
  const locale = currentUiLocale();
  const key = keys.get(text);
  if (key) return String(i18nFor(locale).t(key, { ns: "ui", ...values, defaultValue: text }));
  if (!values) return text;
  return text.replace(/\{\{(\w+)\}\}/g, (match, name: string) => String(values[name] ?? match));
}

/** Human-readable metadata/schema only; keys, URLs, entities and numeric values remain untouched. */
export function localizeDisplayObject<T>(value: T): T {
  if (typeof value === "string") return uiText(value) as T;
  if (Array.isArray(value)) return value.map(localizeDisplayObject) as T;
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(Object.entries(value).map(([key, child]) => {
    if (["name", "headline", "description", "text", "articleBody", "caption", "alternateName"].includes(key)
      && typeof child === "string") return [key, uiText(child)];
    if (key === "inLanguage") return [key, currentUiLocale()];
    return [key, typeof child === "object" ? localizeDisplayObject(child) : child];
  })) as T;
}